import React from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, List, ListItem, ListItemText, Typography, ListItemIcon } from '@mui/material';

const NestedList = ({ items, level = 0 }) => (
    <List disablePadding sx={{ padding: '10px' }}>
        {items.map((item, index) => (
            <React.Fragment key={index}>
                <ListItem sx={{ pl: level * 2 }}>
                    <ListItemIcon sx={{ minWidth: '30px' }}>
                        <FiberManualRecordIcon fontSize="small" />
                    </ListItemIcon>
                    
                    <ListItemText
                        primary={
                            <Typography 
                                component="span" 
                                fontWeight={level === 0 ? 'bold' : 'normal'}
                                variant="body1"
                            >
                                {item.key}
                            </Typography>
                        }
                        secondary={item.definition ? item.definition : null}
                    />
                </ListItem>

                {item.subItems && <NestedList items={item.subItems} level={level + 1} />}
            </React.Fragment>
        ))}
    </List>
);

const Notes = ({ Definition }) => (
    <Box>
        <NestedList items={Definition} />
    </Box>
);

export default Notes;
